import type { ModuleManifest } from "./types";

export const assetsManifest: ModuleManifest = {
  name: "assets",
  label: "Asset",
  labelPlural: "Asset",
  coreBOSModule: "Assets",
  wsidPrefix: "43x",
  type: "standard",
  routes: {
    list: "/assets",
    show: "/assets/show/:id",
    create: "/assets/create",
    edit: "/assets/edit/:id",
  },
  navigation: {
    icon: "LaptopOutlined",
    order: 12,
    group: "Security",
  },
  routing: {
    keywords: ["asset", "assets", "installazione", "installazioni", "hardware", "software"],
    searchFields: ["assetname"],
    defaultSort: { field: "assetname", order: "asc" },
  },
  context: { supported: true, entityKey: "assets" },
  fields: [
    { name: "assetname", label: "Nome Asset", type: "string", required: true },
    { name: "asset_type", label: "Tipo", type: "picklist" },
    { name: "category", label: "Categoria", type: "picklist" },
    { name: "risk_evaluation", label: "Valutazione Rischio", type: "picklist" },
    { name: "asset_status", label: "Stato", type: "picklist" },
    { name: "account", label: "Account", type: "reference" },
    { name: "product", label: "Prodotto", type: "reference" },
    { name: "supplier", label: "Fornitore", type: "reference" },
    { name: "location", label: "Ubicazione", type: "string" },
    { name: "elaborative_system", label: "Sistema Elaborativo", type: "picklist" },
    { name: "operating_system", label: "Sistema Operativo", type: "picklist" },
    { name: "cloudservice", label: "Cloud Service", type: "picklist" },
    { name: "backup_freq", label: "Frequenza Backup", type: "picklist" },
    { name: "access_level", label: "Livello Accesso", type: "picklist" },
    { name: "cryptography", label: "Crittografia", type: "boolean" },
    { name: "antivirus", label: "Antivirus", type: "boolean" },
    { name: "firewall", label: "Firewall", type: "boolean" },
    { name: "license_type", label: "Tipo Licenza", type: "picklist" },
    { name: "license_expiration", label: "Scadenza Licenza", type: "date" },
    { name: "treated_data", label: "Dati Trattati", type: "string" },
    { name: "description", label: "Descrizione", type: "text" },
    { name: "assigned_user_id", label: "Assegnato a", type: "reference" },
  ],
  relationships: [
    { module: "Accounts", field: "account", label: "Account", icon: "BankOutlined", displayField: "accountname" },
    { module: "Products", field: "product", label: "Prodotto", icon: "ShoppingOutlined", displayField: "productname" },
    { module: "ThirdParties", field: "supplier", label: "Fornitore", icon: "TeamOutlined", displayField: "thirdpartiesname" },
  ],
  requiredFields: ["assetname"],
  viewStrategy: "generic",
};
